import React from 'react';
import MapComponent from './components/MapComponent'

const App = () => {
  return <div className='App'>
    <MapComponent/>
  </div>
}

export default App